export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Automatically keep track of your google ranking in just one click."])}
      },
      "ja": {
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["このツールでは、定期的なGoogleランキングを確認できます。"])}
      }
    }
  })
}
